import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase'

let adminCache = new Map()
const CACHE_TTL = 5 * 60 * 1000

export async function checkIsAdminTeacher(email) {
  if (!email) return false

  const normalized = email.trim().toLowerCase()

  const cached = adminCache.get(normalized)
  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.value
  }

  try {
    const docRef = doc(db, 'adminTeachers', normalized)
    const docSnap = await getDoc(docRef)
    const isAdmin = docSnap.exists()
    adminCache.set(normalized, { value: isAdmin, timestamp: Date.now() })
    return isAdmin
  } catch (error) {
    console.error('Erreur lors de la vérification admin teacher:', error)
    return false
  }
}

export function canEditExercise(userId, exercise, isAdmin) {
  if (!userId || !exercise) return false
  if (exercise.authorId === userId) return true
  return !!isAdmin
}

export function clearAdminCache() {
  adminCache = new Map()
}
